import * as React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { Divider } from '@mui/material';
import Logo from "../resources/PMA-logo.png"
import LogoJpeg from "../resources/PMA-logo.jpg"
import PMAMenu from './PMAMenu';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase.config';

const pages = ['Home', 'About Us', 'membership'];
const settings = ['Login', 'Logout'];


function PMANavBar() {


    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const navigateToHome = useNavigate();

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const handleLogin = () => {
        navigateToHome('admin');
        handleCloseUserMenu();        
    }

    const handleLogout = () => {
        sessionStorage.removeItem("uemail");
        auth.signOut();  
        navigateToHome('/');
        handleCloseUserMenu();
    }


    return (
    <div> 
          <AppBar position="sticky" color= 'transparent'>
            <Container maxWidth="xl">
                <Toolbar disableGutters>

                    <Box
                        component="img"
                        sx={{
                        height: 64,
                        pb: 1,
                        pt: 1
                        }}
                        alt="Your logo."
                        src={Logo}
                        onClick={() => navigateToHome('/')}
                    />
                    
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

                    </Box>
                    
                    <Box sx={{ mr:2 }}>
                        <Button variant='contained'
                        onClick={() => navigateToHome('membership')}> 
                                Join Us
                        </Button>
                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Admin ONLY">
                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                {/* <Avatar alt="Your Name" src="/static/images/avatar/2.jpg" /> */}
                                <Avatar alt="PMA Admin" src={LogoJpeg} />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {settings.map((setting) => (
 
                                    <MenuItem key={setting} 
                                    onClick={setting === 'Login' ? handleLogin : handleLogout}>
                                        <Typography textAlign="center">{setting}</Typography>
                                    </MenuItem>  
 
                            ))}
                        </Menu>
                    </Box>

                    {/* draw a header/footer line component */}
        

                </Toolbar>
                
                {/* draw a header/footer line component */}
                <Box sx={{ bgcolor: 'primary.main', 
                    flexGrow: 1, border: 1, 
                    height: '0.1rem', width: 'auto'}} />
                <PMAMenu />

            </Container>
        </AppBar>

        {/* draw a header/footer line component */}
        {/* <Box sx={{ bgcolor: 'primary.main', 
        flexGrow: 1, border: 1, 
        height: '0.1rem', width: 'auto'}} />
        <PMAMenu /> */}

    </div>


    );

}

export default PMANavBar;
